<template>
  <ui-modal-layout :title="tr('Your subscription is now active!')">
    <lottie-animation
      class="mx-auto w-full max-w-72"
      :animation-data="require('@/assets/lottie/shoprenter-success-owl.json')"
      :auto-play="true"
      :loop="true"
    />
    <p class="m-0 text-center text-muted-foreground">
      {{ tr('Your subscription has been successfully activated and all features are now available.') }}
    </p>

    <template #footer>
      <ui-button class="w-full" :disabled="isLoading" @click="() => confirm()">
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Let\'s go!') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';
import { LottieAnimation } from 'lottie-web-vue';

export default {
  name: 'ShoprenterSubscriptionSuccessModal',
  components: {
    LoaderCircleIcon: LoaderCircle,
    LottieAnimation,
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    confirm() {
      this.isLoading = true;
      this.$root.fetchUserData()
        .then(resp => {
          this.$emit('confirmed');
          this.$emit('close');
          return resp;
        })
        .catch(() => this.$emit('close'));
    },
  },
};
</script>
